import { withErrorBoundary } from "@sentry/nextjs";
import { FC, useEffect, useState } from "react";
import { theme } from "styles";

type Props = {
  percent: number;
  transition: number;
  className?: string;
};

export const Chart: FC<Props> = withErrorBoundary(({ percent, transition, className = "" }) => {
  const [currentPercent, setCurrentPercent] = useState(0);
  const [currentPercentBackgroundCircle, setCurrentPercentBackgroundCircle] = useState(0);
  const msBetweenRerenders = 10;

  const percentageIncrement = (msBetweenRerenders * percent) / transition;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentPercent((prevPercent) => {
        if (prevPercent < percent) {
          return prevPercent + percentageIncrement;
        } else {
          clearInterval(timer);

          return percent;
        }
      });

      setCurrentPercentBackgroundCircle((prevPercentBackgroundCircle) => {
        if (prevPercentBackgroundCircle + (100 * percentageIncrement) / percent > 100) {
          return 100;
        } else {
          return prevPercentBackgroundCircle + (100 * percentageIncrement) / percent;
        }
      });
    }, msBetweenRerenders);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRadFromDeg = (deg: number) => {
    return deg * (Math.PI / 180);
  };

  const getXCoordinate = (percent: number) => {
    if (percent === 100) return 50.9999;

    return 51 + Math.sin(getRadFromDeg(percent * 3.6)) * 50;
  };

  const getYCoordinate = (percent: number) => {
    return 51 - Math.cos(getRadFromDeg(percent * 3.6)) * 50;
  };

  return (
    <svg viewBox="0 0 102 102" className={className}>
      <path
        d={`M 51 51 L 51 1 A 50 50 0 ${currentPercentBackgroundCircle > 50 ? 1 : 0} 1 ${getXCoordinate(
          currentPercentBackgroundCircle
        )} ${getYCoordinate(currentPercentBackgroundCircle)} Z`}
        stroke={theme.colors.dusk["70"]}
        strokeWidth="2"
        fill={theme.colors.dusk["70"]}
      />
      <path
        d={`M 51 51 L 51 1 A 50 50 0 ${currentPercent > 50 ? 1 : 0} 1 ${getXCoordinate(
          currentPercent
        )} ${getYCoordinate(currentPercent)} Z`}
        stroke="#c2c2c2"
        strokeWidth="2"
        fill="rgba(227, 222, 253, 1)"
      />
    </svg>
  );
}, {});
